import React, { useEffect, useState } from 'react';
import Team from './../components/TeamComponent';
import InfoCards from './../components/InfoComponent';
import CeoMessage from './../components/CeoMessageComponent';
import Awards from "../components/AwardsComponent";
import "./AboutView.css";
import { getCertificates } from "../api";
import backgroundImage from "./../assets/aurora_lights.avif"; // Adjust the path as needed

export default function AboutUs() {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    document.title = "About Us | Aurora";

    const fetchCertificates = async () => {
      try {
        const data = await getCertificates();
        setCertificates(data);
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    fetchCertificates();
  }, []);

  return (
    <>
      {/* Our Story */}
      <section
        className="w-[90%] py-2 px-auto border border-white shadow-[0_4px_6px_rgba(255,165,0,0.5)] rounded-lg my-6 mx-auto"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-5xl mx-auto">
          <h1 className="text-6xl font-bold text-center text-navy-900 mb-4">
            Our Story
          </h1>
          <div className="text-lg text-center text-white space-y-3 py-4">
            <p>
              Inspired by the breath-taking beauty of the aurora borealis,
              Aurora Energy aims to illuminate the path to a sustainable future
              in Zimbabwe's renewable energy sector.
            </p>
            <p>
              Our name is derived from the spectacular display of colored lights
              that occurs when charged particles from the solar wind interact
              with the Earth's magnetosphere. This natural phenomenon symbolizes
              our mission to bring light, energy, and hope to our communities.
            </p>
            <p>
              At Aurora Energy, we are committed to providing cleaner,
              affordable, environmentally friendly, and sustainable sources of
              power. We believe that every Zimbabwean deserves to harness the
              abundant solar energy available in our country and enjoy the
              benefits of high-quality, reliable, and efficient renewable energy
              solutions.
            </p>
            <p>
              Our goal is to make sustainable energy accessible, affordable, and
              mainstream, empowering individuals, businesses, and communities to
              thrive while protecting our planet for future generations.
            </p>
          </div>
        </div>
      </section>

      {/* Our Info */}
      <InfoCards />

      {/* CEO Message */}
      <CeoMessage />

      {/* Our Team */}
      <Team />
      {/*awards */}
      <section className="py-2 px-auto my-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-bold text-center text-navy-900 mb-4">
            Our Awards
          </h1>
          <Awards />
        </div>
      </section>
      {/* Certificates */}
      <section className="py-2 px-auto border border-white shadow-[0_4px_6px_rgba(255,165,0,0.5)] rounded-lg my-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-bold text-center text-navy-900 mb-4">
            Our Certifications
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {certificates.map((certificate, index) => (
              <div key={index} className="w-full flex justify-center">
                <a
                  href={certificate.path}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-gradient-to-r from-navy-900 to-orange-500 text-white hover:text-orange-300 font-semibold rounded-lg shadow-lg transition"
                >
                  {certificate.title}
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
